import { UploaderResponseError } from "./uploader-response-error";

export class InvalidVideoBitrateResponseError extends UploaderResponseError {
  constructor(public message = "fileUploader.invalidBitrate") {
    super(message);
  }
}
